import {useEffect, useLayoutEffect, useState} from "react";
import {GetAllServiceType} from "../../../../../reduxToolkit/ServiceType/ServiceTypeApi";
import {toast} from "react-toastify";
import routes from "../../../../../Routes/routes";
import {Supplier} from "../../../../../models/Supplier";
import { GetEmployeeSupplierByItId,
    UpdateSupplier
} from "../../../../../reduxToolkit/EmployeeProviders/EmployeeProvidersApi";
import {getPhotoPicker, PHOTO_PICKER_MODEL} from '../../../../../components/PhotoPicker/SubComponent/Models/Models';
import {errorMsg, isEmailFormat, isPhoneFormat} from '../../../../../Apis/functions';
import {useLocation} from "react-router-dom";
import IconPersonDefault from "../../../../../assets/ImagesDefaults/ic-person-v2.svg";
import { GetUserRestriction } from "../../../../../reduxToolkit/restrictions/RestrictionApi";
import HandleChange from './../../../../../Helpers/HandleChange';

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 *
 */


export const EmployeeFlowSupplierUpdateApp = ({
    t,
    params,
    dispatch,
    navigate,
    permission,
    setEmptyFields,
    isValidDob,
    isValidPassword,
    photoPicker,
    setSecretModal,
    setSecretKey,
    setSteps,
    modified,
    setModified,
    setPhotoPicker,
    setIsValidDocumentId,
    isValidDocumentId,
    extraData,
    extraDataEnabled,
    setExtraData,
    setExtraDataEnabled,
    headersList
}) => {
    const location = useLocation();
    let { state } = location;
    const [getAllServiceType, setGetAllServiceType] = useState([]);
    const [user, setUser] = useState({ ...Supplier });
    const [showUnlinkBtn, setShowUnlinkBtn] = useState(false);

    /**
     * Generates the steps for the employee update flow.
     * Adds "other_details" step only when extra data is enabled.
     */
    const STEP_EMPLOYEE_UPDATE = (extraDataEnabled) => {
        if (extraDataEnabled) {
            return [t('company_details'),  t('manager_details'), t('other_details'), t('photo')];
        }
        return [t('company_details'), t('manager_details'), t('photo')];
    };

    /**
     * Updates the steps dynamically when dependencies change.
     * Ensures UI reflects the correct flow based on extraDataEnabled.
     */
    useLayoutEffect(() => {
        setSteps([...STEP_EMPLOYEE_UPDATE(extraDataEnabled)]);
    }, [extraDataEnabled, t, permission]);
    /**
     * Fetch initial data on component mount:
     * - Service types list
     * - User restrictions to determine if extra data is enabled
     */
    useEffect(() => {
        dispatch(GetAllServiceType()).then(
            ({
                payload: {
                    data: { data },
                },
            }) => {
                setGetAllServiceType(data);
            },
        );
        // Fetch user restrictions to check if extra data is allowed
        dispatch(GetUserRestriction()).then(
            ({
                payload: {
                    data: { data, success },
                },
            }) => {
                if (success === true) {
                    setExtraDataEnabled(data?.extraDataSupplier);
                }
            },
        );
    }, [dispatch]);

    // Form handeler Function
    const FormHandler = () => {
        const emailOk = isEmailFormat(user.email);
        const phoneOk = isPhoneFormat(user.phoneNumber);

        if (!user.isValid() ||
            !isValidDob ||
            !phoneOk ||
            !emailOk ||
            !isValidPassword
        ) {
            toast.warn(t('please_fill_all_fields'));
            setEmptyFields(true);
        } else {
            setEmptyFields(false);
            updateSupplier();
        }
    };

    const updateSupplier = () => {
        let imageFile = getPhotoPicker(photoPicker);
        const addPw = user?.password?.trim() !== '' && user?.password !== null;

        dispatch(
            UpdateSupplier({
                data: user.toCreateUpdate(addPw ? user?.password.trim() : null, extraData),
                file: imageFile,
                updateImage: user.selfie !== null,
                setModified: setModified,
            }),
        ).then(
            ({
                payload: {
                    data: { data, success, code },
                },
            }) => {
                if (success) {
                    if (data?.secret && addPw) {
                        setSecretModal(true);
                        setSecretKey(data?.secret);
                    }
                    toast.success(t('has_been_updated_successfully'));
                    setEmptyFields(false);
                } else {
                    errorMsg(code);
                    setEmptyFields(true);
                }
            },
        );
    };

    useEffect(() => {
        getSupplierInfo();
    }, []);

    useEffect(() => {
        if (modified) {
            getSupplierInfo();
            setModified(false);
        }
    }, [modified]);

    const getSupplierInfo = () => {
        dispatch(GetEmployeeSupplierByItId(params?.id)).then(
            ({
                payload: {
                    data: { success, data },
                },
            }) => {
                if (success === true) {
                    const deviceId = data?.deviceId ?? null;
                    setUser((prevData) => ({
                        ...prevData,
                        ...data,
                    }));

                    setShowUnlinkBtn(!!deviceId);
                    setExtraData(data?.extraData);
                    if (data?.selfie)
                        setPhotoPicker({
                            ...PHOTO_PICKER_MODEL,
                            previewImage: `data:image/jpeg;base64,${data?.selfie}`,
                            preview: IconPersonDefault,
                        });
                }
            },
        );
    };

    const goBack = () => {
        if (state?.backUrl) {
            navigate(state.backUrl, {
                state: { currentTab: state?.currentTab },
            });
        } else {
            navigate(routes.suppliers.main);
        }
    };

    /**
     * This function handles changes in the form fields for extra data. It updates the 'extraData' state by spreading the previous data
     * and updating the specific field (identified by 'name') with the new value from the form input.
     * @param e
     */
    const { handleChange } = HandleChange({
    model: extraData,
    setModel: setExtraData,
    });

    return {
        user,
        setUser,
        FormHandler,
        getAllServiceType,
        goBack,
        showUnlinkBtn,
        extraData,
        handleChange,
        setExtraData,
        headersList,
    };
};
